import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'gtd-indeterminate-checkbox',
  templateUrl: 'indeterminate-checkbox.component.html',
})
export class IndeterminateCheckboxComponent {
  @Input() checked: boolean;
  @Output() checkboxChange = new EventEmitter();

  emitCheckboxChange(): void {
    this.checkboxChange.emit();
  }
}
